<template>
<b-card>
  <template #header>
    <h5 class="card-title">Achievement</h5>
  </template>
  <div class="d-flex align-items-center">
    <template v-if="showContent">
      <b-form-checkbox @change="$emit('updateShowSection', $event, 'home-achievement', apiGet)" id="preview" value="Y" unchecked-value="N" name="preview" v-model="showContent">
        Show Section?</b-form-checkbox>
    </template>

    <b-button variant="secondary" class="btn-rounded ml-auto" v-if="previewOpen" @click="closePreviewForm">
      Close <i class="fas fa-times ml-2"></i>
    </b-button>
    <b-button variant="outline-info" class="btn-rounded ml-auto" @click="showPreviewUpdate" v-else>
      Update Content <i class="fas fa-pencil-alt ml-2"></i>
    </b-button>

  </div>
  <hr />

  <validation-observer v-slot="{ handleSubmit }" ref="VFormDescription" tag="div" v-if="previewOpen">
    <b-form @submit.prevent="handleSubmit(doSubmitDesc)">
      <b-card class="border mb-0">
        <template #header>
          <h5 class="card-title">
            Content
          </h5>
        </template>
        <b-row class="mb-2">
          <b-col md=4>
            <div class="form-group">
              <label class="control-label">Title <span class="text-danger">*</span></label>
              <b-form-input v-model="row.asc_title" />
              <VValidate name="Title" v-model="row.asc_title" rules="required|min:3|max:160" />
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md=4>
            <div class="form-group">
              <label class="control-label">Description</label>
              <b-form-textarea :rows="3" v-model="row.asc_content" />
              <VValidate name="Description" v-model="row.asc_content" rules="min:3" />
            </div>
          </b-col>
        </b-row>
        <template #footer>
          <div class="text-right">
            <b-button variant="secondary" class="btn-rounded mr-3" @click="closePreviewForm">Cancel</b-button>
            <button type="submit" class="btn btn-info btn-rounded">Save Changes</button>
          </div>
        </template>
      </b-card>
    </b-form>
  </validation-observer>

  <template v-else>
    <div class="row justify-content-center mt-3">
      <div class="col-md-8 text-center">
        <h3>{{row.asc_title}}</h3>
        <div class="sect-heading__line"></div>
        <p>{{row.asc_content}}</p>
      </div>
    </div>
    <b-row>
      <b-col lg="4" v-for="(v, k) in achievement" :key="`achievement${k}`">
        <div class="why_choose_us_wrap h-100">
          <div class="why_choose_us_wrap h-100">
            <div class="desc_wrap text-center">
              <h2 class="font-weight-bold">{{ v.description }}</h2>
              <h3 class="pb-0">{{ v.title }}</h3>
            </div>

            <div class="bullet-cta">
              <b-button type="button" @click="openModal('modalAchievement', {...v, keyData: k})" variant="warning" class="btn-icon mr-0 rounded-pill" v-b-tooltip.hover title="Update Achievement">
                <i class="ti-pencil"></i>
              </b-button>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-modal id="modalAchievement" :title="(achievementRow.typeLabel == 'Added' ? 'Add' : 'Update') + ' achievement'" size="lg">
      <validation-observer v-slot="{ handleSubmit }" ref="VFormachievement">
        <b-form @submit.prevent="handleSubmit(doSubmit)">
          <b-row>
            <b-col md=5>
              <div class="form-group mb-2">
                <label class="control-label">Title <span class="text-danger">*</span></label>
                <input type="text" class="form-control" placeholder="Title" v-model="achievementRow.title">
                <VValidate name="Title" v-model="achievementRow.title" :rules="{required: true, min: 3, regex:/^[^\s]+(\s+[^\s]+)*$/}" />
              </div>
            </b-col>
            <b-col md=5>
              <div class="form-group mb-2">
                <label class="control-label">Value <span class="text-danger">*</span></label>
                <input type="text" class="form-control" placeholder="Value" v-model="achievementRow.description">
                <VValidate name="Value" v-model="achievementRow.description" :rules="{required: true, min: 3, regex:/^[^\s]+(\s+[^\s]+)*$/}" />
              </div>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      <template #modal-footer="{close}">
        <div class="text-right">
          <b-button class="btn-rounded" variant="outline-secondary" @click="close">Cancel</b-button>
          <b-button type="button" @click="doSubmit" class="btn-rounded ml-2" variant="primary">Save Changes</b-button>

        </div>
      </template>
    </b-modal>
  </template>

</b-card>
</template>

<script>
import Gen from '@/libs/Gen.js'
// let _ = global._
export default {
  props: {
    modulePage: String
  },
  data() {
    return {
      previewOpen: false,
      achievementRow: {},
      row: {},
      achievement: [],
      validation: {},
      showCompanyBrief: false,
      showContent: null
    }
  },
  computed: {
    parent() {
      return this.$parent.$parent.$parent
    }
  },
  mounted() {
    this.apiGet()
  },
  methods: {
    showPreviewUpdate() {
      this.previewOpen = true
    },
    closePreviewForm() {
      this.previewOpen = false
    },
    openModal(modal, data = null) {
      this.$bvModal.show(modal)
      this.$set(this, 'achievementRow', {
        typeLabel: 'Added'
      })
      if (data) this.$set(this, 'achievementRow', {
        ...this.achievementRow,
        ...data,
        typeLabel: 'Updated'
      })
    },
    doSubmit() {
      this.$refs.VFormachievement.validate().then(success => {
        if (!success) return
        this.parent.swalLoading()
        let achievement = this.achievement.map((dtachievement, kachievement) => {
          if (kachievement == this.achievementRow.keyData) return {
            ...this.achievementRow,
            keyData: null
          }
          return dtachievement
        })

        Gen.apiRest('/do/' + this.modulePage, {
          data: {
            type: 'updateAchievement',
            ac_value: achievement,
            type_label: this.achievementRow.typeLabel
          }
        }).then(res => {
          if (res) {
            this.$swal({
              title: res.data.message,
              icon: 'success',
            }).then(() => {
              this.$bvModal.hide('modalAchievement')
              this.apiGet()
            })
          }
        }).catch(err => {
          this.$swal({
            title: err.response.data.message,
            icon: 'error'
          })
        })
      })
    },
    doSubmitDesc() {
      this.$refs.VFormDescription.validate().then(success => {
        if (!success) return
        this.parent.swalLoading()
        Gen.apiRest('/do/' + this.modulePage, {
          data: {
            type: 'updateAchievementDescription',
            ...this.row
          }
        }).then(res => {
          if (res) {
            this.$swal({
              title: res.data.message,
              icon: 'success',
            }).then(() => {
              this.closePreviewForm()
              this.apiGet()
            })
          }
        }).catch(err => {
          this.$swal({
            title: err.response.data.message,
            icon: 'error'
          })
        })
      })
    },
    apiGet() {
      Gen.apiRest('/get/' + this.modulePage + '/achievement', {}, 'GET').then(res => {
        this.row = res.data.row
        this.achievement = res.data.achievement
        this.validation = res.data.validation
        this.showContent = res.data.showContent
      })
    }
  }
}
</script>
